<template>
    <HomeContentLayout>
        <Layout>
            <Sider  hide-trigger :collapsed-width="64"  class="siderCls" style="background:#fff; width: 260px;min-width:260px;max-width:260px;" >
                <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"></el-input> 
                <el-tree :data="treeData" 
                         :props="defaultProps" 
                         @node-click="handleNodeClick" 
                         node-key="id"      
                         :default-expanded-keys="['0']"     
                         v-loading="loadingtree"
                         element-loading-text="加载中"
                         element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(255, 251, 255, 0.8)"               
                         :style="{background:'#fff',overflow:'auto',height: scrollerHeight}"
                         highlight-current
                         :filter-node-method="filterNode"
                         ref="eltree"
                         :expand-on-click-node="false">
                    <template v-slot="{node,data}">                                     
                        <span v-if="data.id ==0 "  class="el-icon-notebook-1 nodeRoot" >
                          <span class="nodeLabel">{{ node.label}} </span>
                        </span>                  
                        <span v-else class="el-icon-folder" > 
                            <span class="nodeLabel">{{ node.label}} </span>
                        </span>
                    </template>
                </el-tree>
            </Sider>
            <Layout>
                <Content>
                    <div style="vertical-align:center; padding-left:1px;margin-top:6px;display:flex;height:32px;line-height:32px;background:white;">
                        <el-button @click="addRec" type="text" icon="el-icon-plus" style="margin-right:20px;margin-top:-3px;"> 新增类别</el-button> 
                        <el-input :placeholder="input_hold" v-model="textparam" size="small" @keyup.enter.native="qryTabData" style="width:400px;margin-left:10px;vertical-align:center">
                            <el-select v-model="selparam" slot="prepend" placeholder="请选择列名" clearable @change="elchange" style="width:140px;">
                                <span v-for="item in tabCol" :key='item.key'>
                                    <el-option :label="item.title" :value="item.key"></el-option>
                                </span>
                            </el-select>
                        </el-input>                        
                    </div>     
                    <div>
                    <el-table  :data="baseData" 
                            border                            
                            disabled-hover
                            style="overflow:auto;margin-top:1px;"
                            v-loading="loading"
                            :row-key="getRowKey"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 251, 255, 0.8)"  
                            size="small"
                            ref="tabref"
                            :height="tabHeight" 
                            :max-height="tabHeight" 
                            highlight-current-row
                            @row-click="rowClick"  >
                        <span v-for="(item,index ) in tableCol" :key="index">   
                            <el-table-column  v-if="item.key!=='STFG'"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                sortable
                                :min-width="item.width">
                            </el-table-column>
                            <el-table-column  v-if="item.key==='STFG'"
                                prop="item.key"
                                :label="item.title"
                                align="center"                                  
                                width="80">
                                <template slot-scope="scope" >
                                    <el-checkbox disabled false-label="" true-label="Y" v-model="scope.row.STFG" >&nbsp;</el-checkbox>
                                </template>
                            </el-table-column> 
                        </span> 
                        <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                            width="150">
                            <template slot-scope="scope">
                                <el-button size="small"   type="text" icon="el-icon-edit" @click="editRec(scope.row,scope.$index)">编辑</el-button>
                                <el-button size="small"   type="text" icon="el-icon-close" @click="delRec(scope.row,scope.$index)">删除</el-button>   
                            </template>
                        </el-table-column>                           
                    </el-table>
                    </div>
                    <Modal v-model="addModal"  :closable="false"  scrollable  width="50%">
                        <Form ref="addForm" :model="formCol" :label-width="100"  :rules="ruleValidate"  label-position="right" inline >
                            <span v-for="(item,index) in tabCol" :key="index" >
                                <FormItem :label="item.FLDNM" :prop="item.FLDNO" v-if="item.FHIDE==='N'" class="item-width" >  
                                    <el-checkbox border v-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="" v-model="formCol[item.FLDNO]"  style="width:100%;"></el-checkbox>                                
                                    <Input type="text" v-else :disabled="item.DISABLED==='Y'?true:false" v-model="formCol[item.FLDNO]"  clearable/>
                                </FormItem>
                            </span>
                        </Form>                     
                        <div slot="footer" style="height:24px;">
                            <Button type="primary" style="margin-right:25px;"  @click="addModal=false">取消</Button>
                            <Button type="primary"   @click="modal_ok">确定</Button>
                        </div>
                        <div slot="header" style="height:10px;line-height:10px">
                            <span style="font-weight:600;font-size:14px;color:white">{{type==='create'?'新增记录 （子英文名称为必填！）':'修改记录'}}</span>
                        </div>
                    </Modal>
                    <Modal v-model="imgModal" scrollable  width="560" :footer-hide="true">
                        <el-image fit="scale-down" style="width:540px;height:500px;" :src="imgsrc"></el-image>
                    </Modal>
                </Content>
            </Layout>
        </Layout>
    </HomeContentLayout>
</template>

<script>
    import { getTabColOrData } from '../../api/user';
    export default {
        name: "prdtype_mgt",
        data(){
            return {
                treeData:[] ,//  树数据
                filterText: '',
                menuVisible:false,
                ruleValidate:{
                    "CNAME":[{"required":true,"message":"所属不能为空","trigger":"change"}],
                    "ENAME":[{"required":true,"message":"所属不能为空","trigger":"change"}],
                    },
                nodeData:{},
                input_hold:'请输入内容...',
                defaultProps: {  //el-tree 默认字段属性
                    children: 'children',
                    id:'id',
                    icon:'icon',
                    label: 'label'
                },
                uploadData:{}, //上传数据
                Accept: "png,jpg,jpeg,webp,gif", //上传文件格式限制
                notNull:[],
                resultCode:{}, //状态码
                treeid :'0',
                type: 'create',
                v_lvl:0,
                formCol:{}, //表格单行记录 model
                addModal:false, //modal 
                loading:false,// table加载bool
                textparam:'', // input 绑定值
                selparam:'',// select 绑定值
                tabCol:[] ,//表列集合
                tableCol:[] ,//表列格式化集合
                baseData:[] ,//表数据
                allData:[] , //保存取到所有数据
                nodeLabel:'产品类别',
                rowIndex:'-1', //行号
                rowCode:'-1',
                loadingtree:false,
                stfgBool:true,
                page:1,
                // 初始化信息总条数
                dataCount:0,
                // 每页显示多少条
                pageSize:25,
                v_url:this.$store.state.queryUrl , //api请求路径
                v_urlcol:this.$store.state.baseUrl+'sysprivs/getFormColumn',
                v_urldata:this.$store.state.baseUrl+'sysprivs/getRecuriveRec', //api请求路径(递归查询)
                v_username:this.$cookies.get('v_username'), //api 请求用户
                v_password:this.$cookies.get('v_password') ,//api 请求密码
                v_requrl:this.$store.state.baseUrl+'sysprivs/getTableRecMany', //动态请求url接口
                uploadUrl:this.$store.state.baseUrl +'auth/login/uploadImg',
                imgsrc:'',
                imgModal :false,
            }
        },
        created(){
            //初始化
            this.getData();
            this.getTabCol();
            this.getFormCol();
            this.getTabData('parentno','0','','','','');
        },
        mounted(){
            //动态生成表单验证规则
            getTabColOrData(this.v_url,this.v_username,this.v_password,'v_sys_form_fld','idseq','16','fty','HEAD','NOTNULL','Y').then((res) => {
                let ruleObj={}
                let ruleVal=[]
                this.notNull = res.data
                res.data.forEach(item => {
                    let v_fldnm =item.FLDNM
                    let obj1={required:true,message:v_fldnm+'不能为空'}
                    ruleVal =[]
                    ruleVal.push(obj1)
                    ruleObj[item.FLDNO]=ruleVal                  
                });
                this.ruleValidate =ruleObj
            });    
        },
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 140) + 'px';
            }, 
            tabHeight(){
                return (window.innerHeight - 150) + 'px';
            },
            btnupload: function(){
                if (this.rowIndex ==='-1' ) {
                    return true
                }else{
                    return false
                }
            }
            
        },
        watch:{
            filterText(val) {
                this.$refs.eltree.filter(val);
            }
        },
        destroyed(){
        },
        methods:{
            getRowKey(row){
                return row.IDSEQ
            },
            //节点过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //节点点击
            handleNodeClick(data){
                this.nodeLabel=data.label;            
                this.treeid =data.id
                this.v_lvl =data.icon
                this.getTabData('parentno',data.id,'','','','');
            },
            //获取表行数据
            rowClick (row, index) {
                this.formCol = JSON.parse(JSON.stringify(row))  //深拷贝 //获取行数据
                this.rowIndex =index
                this.rowCode =row.SUBNO
            },
 
            //确定
            modal_ok(){
                var vm=this;
                this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                    if (!this.formCol[item.FLDNO] ){
                       this.stfgBool =false 
                       this.$Message.error(item.FLDNM+'不能为空'); 
                       return true
                    }else{
                      this.stfgBool =true  
                    }
                })
                //发起保存请求   
                if (this.stfgBool) 
                    this.$axios({
                        method: 'post',
                        url:vm.$store.state.baseUrl+'sysprivs/formOneSave?username='+vm.$cookies.get('v_username')+'&password='+vm.$cookies.get('v_password'),
                        data: {p_json:JSON.stringify(vm.formCol), p_table:'PRD_CATEGORY'},
                    }).then(res=>{      
                        if(res.data.result =='OK')  {          
                            vm.addModal =false   
                            vm.getTabData('parentno',vm.treeid,vm.selparam,vm.textparam,'','')                           
                            //vm.getData()       
                        }else{
                            this.$Message.error(res.data.result)
                        }        
                    }) 
                //}
            } ,
            //新增
            addRec(){
                this.addModal =true
                this.type ='create'
                this.$refs.tabref.setCurrentRow()
                this.formCol ={STFG:'',LVL:Number(this.v_lvl)+1}
                this.rowIndex ='-1'
                this.formCol.PARENTNO =this.treeid
                this.formCol.PCNAME =this.nodeLabel
                
            },
            //修改
            editRec(){
                this.addModal =true
                this.type ='edit'
            },
            //删除
            delRec(row,index){
                if (this.rowCode==='0'){
                    this.$Message.error('根结点不能删除')
                }else{
                    this.$Modal.confirm({
                        title: '删除确认',
                        content: '<p>你确定要删除此行记录吗</p>',
                        onOk: () => {
                            //发起删除请求
                            var vm=this;
                            this.$axios({
                                method: 'post',
                                url:vm.$store.state.baseUrl+'sysprivs/delTableRec?username='+vm.$cookies.get('v_username')+'&password='+vm.$cookies.get('v_password'),
                                data: {p_key:'SUBNO',p_value:vm.rowCode,p_table:'PRD_CATEGORY'},
                            }).then(res=>{    
                                if(res.data.code =='200')  {           
                                    vm.getTabData('parentno',vm.treeid,vm.selparam,vm.textparam,'','')      
                                }else{
                                    this.$Message.error(res.data.message)
                                }        
                            }) 
                        }
                    });
                }
            },
 
            // el-select 改变时 影响el-input 的 placeholder
            elchange(val){  // 这个val 就是 el-select 的 value
                let obj ={}
                obj =this.tabCol.find(item=>{
                    return item.key===val
                })
                this.input_hold='请输入'+obj.title+' 的值'
            },
            //查询事件
            qryTabData(){
                //this.getTabData('parentno',this.treeid,this.selparam,this.textparam,'','');
                var vm=this
                this.loading =true
                getTabColOrData(this.v_requrl,this.v_username,this.v_password,'V_PRD_CATEGORY_ITM','parentno',this.treeid,'','','','',' and upper('+this.selparam+') like \'%'+this.textparam+'%\'').then((res) => {
                    vm.baseData = res.data
                    this.loading =false
                });  
            },
            // 获取 树形控件数据
            getData() {  
                var vm=this;
                vm.loadingtree=true
                this.$axios({
                    method: 'post',
                    url:vm.$store.state.baseUrl+'sysprivs/getElTreeData?username='+vm.$cookies.get('v_username')+'&password='+vm.$cookies.get('v_password'),
                    data: {p_table:vm.LANG==='English'?'V_PRD_CATEGORY_EN':'V_PRD_CATEGORY3'}
                }).then(function(res){                  
                    vm.treeData =res.data;   
                    if(res.data.length > 0 ){
                        //'nextTick()' 下次dom更新时触发回调函数
                        vm.$nextTick().then(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeid)
                        })
                    }     
                    vm.loadingtree =false          
                })                              
            },
            //获取表列头字段
            getTabCol(){
                var vm=this
                getTabColOrData(vm.v_url,vm.v_username,vm.v_password,'v_sys_form_fld','idseq','24346','fty','HEAD','thide','N',' order by sortby,lstseq').then((res) => {
                    vm.tabCol = res.data
                    for (let k=0; k<res.data.length; k++){
                        vm.tableCol.push({ //向数组的开头 添加序列号
                            title: res.data[k].title,
                            key: res.data[k].key,
                            align: res.data[k].align,
                            width: res.data[k].width,
                            sortable: res.data[k].sortable?true:false,
                        })
                    }
                });
            },
            //获取表单字段
            getFormCol(){
                var vm=this
                getTabColOrData(vm.v_urlcol,vm.v_username,vm.v_password,'v_sys_form_fld','idseq','24346','fty','HEAD','thide','N','').then((res) => {
                    vm.formCol = res.data
                });
            },
            //获取表数据
            getTabData(v_key,v_value,v_key2,v_value2,v_key3,v_value3){
                var vm=this
                this.loading =true
                getTabColOrData(this.v_requrl,this.v_username,this.v_password,'V_PRD_CATEGORY_ITM',v_key,v_value,v_key2,v_value2,v_key3,v_value3,'').then((res) => {
                    vm.baseData = res.data
                    this.loading =false
                    //setTimeout(()=>{this.loading =false},2000) //测试效果
                });               
            }
        }
    }
</script>
<style lang="scss" scoped>
    ::v-deep .el-table {
        th {
            padding: 0px ;
        }
        thead{
            height: 15px !important;
            color:rgb(71, 70, 70);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:11px;
        }   
    }
</style>
<style lang="less"  >
    .menu__item {
        width: 100%;
        display: block;
        line-height: 20px;
        text-align: center;
        margin-top: 10px;
        text-align: center;

    }
 
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
</style>
